export async function revealKenoRound(round, { signal, reduced, onReveal }) {
  const abortError = () => Object.assign(new Error('Presentation cancelled'), { name: 'AbortError' });
  if (signal?.aborted) throw abortError();
  if (reduced) { onReveal(10); return; }
  for (let count = 1; count <= 10; count++) {
    await new Promise((resolve, reject) => {
      const stop = () => { clearTimeout(timer); reject(abortError()); };
      const timer = setTimeout(() => { signal?.removeEventListener('abort', stop); resolve(); }, count === 1 ? 180 : 150);
      signal?.addEventListener('abort', stop, { once: true });
      if (signal?.aborted) { signal.removeEventListener('abort', stop); stop(); }
    });
    if (signal?.aborted) throw abortError();
    onReveal(count);
  }
}
